import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "./common/api";

interface AuthContextProps {
  isAuthenticated: boolean;
  userProfile: IUserProfile | null;
  login: (token: string) => void;
  logout: () => void;
}

interface IUserProfile {
  user_id: number;
  email: string;
  role: string;
  first_name: string;
  last_name: string;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [userProfile, setUserProfile] = useState<IUserProfile | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsAuthenticated(true);
    }
    const userProfile = localStorage.getItem("userProfile");
    if (userProfile) {
      setUserProfile(JSON.parse(userProfile));
    }
  }, []);

  const login = async (token: string) => {
    localStorage.setItem("accessToken", token);
    setIsAuthenticated(true);

    try {
      const response = await api.get("accounts/users/me/");
      localStorage.setItem("userProfile", JSON.stringify(response.data));
      setUserProfile(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userProfile");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userProfile,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
